import React, { useState } from 'react';
import { Phone, MapPin, Send } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CONFIG } from '../data/villaData';

export default function Contact() {
  const { t } = useLanguage();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const text = `Hello! My name is ${form.name} (${form.email}).\n\n${form.message}`;
    window.open(`https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(text)}`, '_blank');
    setSent(true);
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <section id="contact" className="py-24 md:py-32 bg-[#faf6ef]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.3em] uppercase text-[#b8945e] font-medium mb-4">{t.contact.eyebrow}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-3">{t.contact.title}</h2>
          <p className="text-lg text-stone-600">{t.contact.subtitle}</p>
          <div className="w-20 h-px bg-[#b8945e] mx-auto mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div className="space-y-6">
            <InfoCard icon={Phone} title={t.contact.reservations} value={CONFIG.whatsappDisplay} href={`tel:+${CONFIG.whatsapp}`} />
            <InfoCard icon={MapPin} title={t.contact.address} value={CONFIG.address} />
          </div>

          <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-lg">
            <h3 className="font-serif text-2xl text-stone-900 mb-6">{t.contact.getInTouch}</h3>
            <div className="space-y-4">
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder={t.contact.yourName} required
                className="w-full px-4 py-3 bg-stone-50 border border-stone-200 rounded-xl focus:outline-none focus:border-[#b8945e] focus:bg-white transition-colors" />
              <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} type="email" placeholder={t.contact.yourEmail} required
                className="w-full px-4 py-3 bg-stone-50 border border-stone-200 rounded-xl focus:outline-none focus:border-[#b8945e] focus:bg-white transition-colors" />
              <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={5} placeholder={t.contact.yourMessage} required
                className="w-full px-4 py-3 bg-stone-50 border border-stone-200 rounded-xl focus:outline-none focus:border-[#b8945e] focus:bg-white transition-colors resize-none" />
              <button type="submit" className="w-full py-4 bg-[#b8945e] hover:bg-[#a07d4a] text-white font-semibold rounded-xl flex items-center justify-center gap-2 transition-colors shadow-md">
                <Send size={18} />
                {sent ? '✓ Sent!' : t.contact.send}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

function InfoCard({ icon: Icon, title, value, href }) {
  const Wrapper = href ? 'a' : 'div';
  return (
    <Wrapper href={href} className="flex items-start gap-5 p-6 bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all hover:-translate-y-0.5 group block">
      <div className="w-12 h-12 rounded-full bg-[#b8945e]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#b8945e] transition-colors">
        <Icon size={20} className="text-[#b8945e] group-hover:text-white transition-colors" />
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider text-stone-500 mb-1">{title}</p>
        <p className="text-lg font-medium text-stone-900">{value}</p>
      </div>
    </Wrapper>
  );
}
